<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'request.contact-information.title' | translate }}
    </h2>
    <p class="text-sm text-shui-text-moderate m-0 mb-2 p-0">
        {{ 'request.contact-information.note' | translate }}
    </p>
    <div class="flex flex-col gap-4">
        <sh-input-text
            formControlName="customerEmail"
            [label]="'request.contact-information.customer-email' | translate"
            type="email"
            mandatory
            [error]="formGroup.get('customerEmail')?.touched && formGroup.get('customerEmail')?.invalid"
            [attr.error-message]="getErrorMessage('customerEmail')"
        ></sh-input-text>
        <sh-input-text
            formControlName="tasEmail"
            [label]="'request.contact-information.tas-email' | translate"
            type="email"
            mandatory
            [error]="formGroup.get('tasEmail')?.touched && formGroup.get('tasEmail')?.invalid"
            [attr.error-message]="getErrorMessage('tasEmail')"
        ></sh-input-text>
        <sh-input-text
            formControlName="salesRepEmail"
            [label]="'request.contact-information.sales-rep-email' | translate"
            type="email"
            [error]="formGroup.get('salesRepEmail')?.touched && formGroup.get('salesRepEmail')?.invalid"
            [attr.error-message]="getErrorMessage('salesRepEmail')"
        ></sh-input-text>
        <sh-input-text
            formControlName="pmInstallationEmail"
            [label]="'request.contact-information.project-manager-email' | translate"
            type="email"
            [error]="formGroup.get('pmInstallationEmail')?.touched && formGroup.get('pmInstallationEmail')?.invalid"
            [attr.error-message]="getErrorMessage('pmInstallationEmail')"
        ></sh-input-text>
    </div>
    <div class="w-full h-px bg-shui-base-4 my-8"></div>
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'request.contact-information.additional-contacts-title' | translate }}
    </h2>
    <p class="text-sm text-shui-text-moderate m-0 mb-2 p-0">
        {{ 'request.contact-information.additional-contacts-description' | translate }}
    </p>
    <div class="flex flex-col gap-4" formArrayName="additionalContacts">
        @for (contact of additionalContacts.controls; track contact; let i = $index) {
            <div class="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-2 items-center" [formGroupName]="i">
                <sh-input-text
                    formControlName="title"
                    [label]="'request.contact-information.additional-contact-name' | translate"
                    [error]="contact.get('title')?.touched && contact.get('title')?.invalid"
                    [attr.error-message]="getErrorMessage('additionalContacts.' + i + '.title')"
                ></sh-input-text>
                <sh-input-text
                    formControlName="email"
                    [label]="'request.contact-information.additional-contact-email' | translate"
                    type="email"
                    [error]="contact.get('email')?.touched && contact.get('email')?.invalid"
                    [attr.error-message]="getErrorMessage('additionalContacts.' + i + '.email')"
                ></sh-input-text>
                @if (additionalContacts.length > 1) {
                    <sh-icon icon="delete" color="tertiary" size="s" (click)="removeContact(i)"></sh-icon>
                }
            </div>
        }
        <div class="flex justify-end">
            <sh-button
                [label]="'request.contact-information.add-contact' | translate"
                icon="plus"
                icon-position="start"
                size="max-content"
                color="tertiary"
                (click)="addContact()"
            ></sh-button>
        </div>
    </div>
    <div class="mt-2 flex items-center justify-end">
        <sh-button
            [label]="'common.continue' | translate"
            [disabled]="formGroup.invalid"
            (click)="onContinue()"
        ></sh-button>
    </div>
</div>
